module.exports = __webpack_public_path__ + "static/media/icon_trap_alpha.bc8896e4.svg";